/** @format */

import { JDDevice, JDNativeSystem } from '@jdreact/jdreact-core-lib';
import Images from '../../images';
import Device from '../../utils/device';
import Steep from '../../utils/Steep';
const PropTypes = require('prop-types');
const React = require('react');
const { View, Platform, StyleSheet, StatusBar } = require('react-native');
const NavMoreButton = require('./NavMoreButton');

function NavigationBar(props, context) {
  /**
   * 获取导航栏高度
   */
  const _getNavHeight = () => {
    let height = Steep.NAVIGATION_BAR_HEIGHT;
    if (Platform.OS === 'ios') {
      height += JDNativeSystem.statusBarHeight;
    } else if (Platform.OS === 'android') {
      const transparent = Steep._getSteepStatus();
      // 小于18的sdk不需要顶部的statusBar
      if (Device.isLowSdkVersion(transparent)) {
        height = Steep.NAVIGATION_BAR_HEIGHT;
      } else {
        height += Steep.SYS_BAR_HEIGHT;
      }
    }
    return height;
  };

  /**
   * 设置页面顶部的透明块
   */
  const _setTransparentView = () => {
    let height = Steep._getSteepBarHeight();
    return (
      <View
        style={{
          backgroundColor: props.transparent ? 'transparent' : '#FFF',
          height,
        }}
      />
    );
  };
  const _renderLeft = () => {
    if (typeof props.LeftButton === 'function') {
      return props.LeftButton();
    }
    return null;
    // <JDTouchable
    //   onPress={goBack}
    //   style={[
    //     styles.navigationBtn,
    //     { height: 42 - 2 * JDDevice.getDpx(1) },
    //     props.transparent
    //       ? {
    //           backgroundColor: 'transparent',
    //         }
    //       : {},
    //   ]}
    // >
    //   <JDImage
    //     source={props.transparent ? Images.common.backWhite : Images.common.back}
    //     style={[
    //       styles.backIcon,
    //       props.transparent
    //         ? {
    //             backgroundColor: 'transparent',
    //           }
    //         : {},
    //     ]}
    //   />
    // </JDTouchable>
  };

  const _renderTitle = () => {
    if (typeof props.Title === 'function') {
      return props.Title();
    }
    return null;
    // <JDText style={styles.titleText} numberOfLines={1}>
    //   {props.Title}
    // </JDText>
  };

  const _renderRight = () => {
    let rightButtons = [];
    if (typeof props.RightButton === 'function') {
      const cusRightBtns = props.RightButton();
      if (Array.isArray(cusRightBtns)) {
        rightButtons = rightButtons.concat(cusRightBtns);
      } else {
        rightButtons.push(cusRightBtns);
      }
    }
    if (props.showMoreNav) {
      rightButtons.push(
        <NavMoreButton
          moreNavList={props.moreNavList}
          key="NavMoreButton"
          onMoreNavClick={props.onMoreNavClick}
          onMoreNavItemClick={props.onMoreNavItemClick}
        />
      );
    }
    return rightButtons;
  };

  const goBack = () => {
    if (props.goBack) {
      props.goBack();
    } else {
      context.router.goBack();
    }
  };

  const tmpHeight = _getNavHeight();
  return (
    <View key="NavigationBar" height={tmpHeight}>
      {_setTransparentView()}
      <View
        style={[
          styles.navigationBar,
          props.transparent
            ? {
                backgroundColor: 'transparent',
                borderBottomWidth: 0,
              }
            : {},
        ]}
      >
        <View
          key="left"
          style={[
            styles.navigationAction,
            styles.left,
            { top: 1 + JDDevice.getDpx(1) },
            props.transparent ? { backgroundColor: 'transparent' } : {},
          ]}
        >
          {_renderLeft()}
        </View>
        <View key="middle" style={styles.middle}>
          {_renderTitle()}
        </View>
        <View
          key="right"
          style={[styles.navigationAction, styles.right, props.transparent ? { backgroundColor: 'transparent' } : {}]}
        >
          {_renderRight()}
        </View>
      </View>
    </View>
  );
}
NavigationBar.contextTypes = {
  router: PropTypes.object,
};
const styles = StyleSheet.create({
  navigationBar: {
    backgroundColor: '#FFF',
    height: Steep.NAVIGATION_BAR_HEIGHT,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomWidth: JDDevice.getDpx(1),
    borderBottomColor: 'rgb(203,203,203)',
  },
  navigationAction: {
    position: 'absolute',
    top: 0,
    bottom: 1,
    flexDirection: 'row',
    alignItems: 'center',
    zIndex: 1,
    backgroundColor: '#FFF',
  },
  left: {
    left: 0,
  },
  middle: {
    flex: 1,
    alignItems: 'center',
  },
  right: {
    right: 0,
  },
  titleText: {
    fontSize: JDDevice.getFontSize(36),
    color: '#232326',
    alignSelf: 'stretch',
    textAlign: 'center',
  },
  navigationBtn: {
    width: Steep.NAVIGATION_BAR_HEIGHT,
    height: Steep.NAVIGATION_BAR_HEIGHT,
    justifyContent: 'center',
    alignItems: 'center',
  },
  backIcon: {
    width: (JDDevice.width / 750) * 40,
    height: (JDDevice.width / 750) * 40,
  },
});

export default NavigationBar;
